@if (authService.hasPermission(Permission.PostAssetsRead)) {
  <app-products-recent-section
    title="Recently Enhanced"
    [products]="recentlyEnhancedList"
    filter="RecentlyEnhanced"
    (viewMore)="viewMore($event)"
  ></app-products-recent-section>
}
